module.exports = __webpack_public_path__ + "img/HI.cd081c76.png";